// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"449":"1daa8132","574":"00d018fa","985":"1daa8132"}[chunkId] + ".chunk.css";
};